export const pushDataLayer = (data) => {
  
  if (window.dataLayer) {
    let dataTemp = data;
    if (sessionStorage.user_id) dataTemp.userid =  JSON.parse(window.atob(sessionStorage.user_id));
    window.dataLayer.push(dataTemp);
  }
  else console.log("DATALAYER NOTFOUND. . .", data);
};

export const headerMenu = (action, label) => {
  return {
    event: "generalEvent",
    event_category: "Header Menu",
    event_action: action,
    event_label: label,
  }
};

export const updateData = (label) => {
  return {
    event: "generalEvent",
    event_category: "Update Data AXI",
    event_action: "Perbarui Data",
    event_label: label,
  }
};

export const submitUpdateData = (label) => {
  return {
    event: "generalEvent",
    event_category: "Update Data AXI",
    event_action: "Submit Form Perbarui Data",
    event_label: label,
  }
};

export const waitingUpdateData = (action, label) => {
  return {
    event: "generalEvent",
    event_category: "Update Data AXI",
    event_action: action,
    event_label: label,
  }
};

export const simulasiCicilan = (action, label) => {
  return {
    event: "generalEvent",
    event_category: "Simulasi Cicilan - Homepage",
    event_action: action,
    event_label: label,
  }
};

export const produkPembiayaan = (action, label) => {
  return {
    event: "generalEvent",
    event_category: "Produk Pembiayaan",
    event_action: `Lihat Produk - ${action}`,
    event_label: label,
  }
};

export const testimonial = (action, label) => {
  return {
    event: "generalEvent",
    event_category: "Testimonial",
    event_action: action,
    event_label: label,
  }
};

export const mitraBisnis = (label) => {
  return {
    event: "generalEvent",
    event_category: "Ingin Jadi Mitra Bisnis",
    event_action: "Click Disini",
    event_label: label,
  }
};

export const registrationAxi = (action, label) => {
  return {
    event: "generalEvent",
    event_category: "Registration AXI",
    event_action: action,
    event_label: label,
  }
};

export const registrationNasabah = () => {
  return {
    event: "generalEvent",
    event_category: "Registration Nasabah",
    event_action: "Daftar",
  }
};

export const loginUser = (userId) => {
  return {
    event: "generalEvent",
    event_category: "Login",
    event_action: "Masuk",
    userid: userId,
  }
};

export const searchProduct = (keyword) => {
  return {
    event: "generalEvent",
    event_category: "Search Bar - Homepage",
    event_action: keyword,
  }
};

export const simulasiCicilanPage = (action) => {
  return {
    event: "generalEvent",
    event_category: "Simulasi Cicilan - Homepage",
    event_action: action,
  }
};